import { fetchThemesData, fetchThemeData } from './routines';

export const fetchThemes = (error) => ({
    type: fetchThemesData.TRIGGER,
    error,
});

export const fetchTheme = (error) => ({
    type: fetchThemeData.TRIGGER,
    error,
});
